import { useState } from "react";
import { Fragment } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { ToggleDropdown } from "../../../../../Constant";

export  interface ButtonDropdownListProp {
  btn?: any;
  color: string;
  title?: string;
  options: string[];
  outline?: boolean;
  divider: boolean;
  split?: boolean;
  span?: boolean;
}

const ButtonDropdownList = ({ btn, color, title, options, outline, divider, split, span }: ButtonDropdownListProp) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle {...btn} color={color} outline={outline} caret split={split}>
        {title}
        {span && <span className="visually-hidden">{ToggleDropdown}</span>}
      </DropdownToggle>
      <DropdownMenu className="dropdown-block">
        {options.map((item, i) => (
          <Fragment key={i}>
            <DropdownItem>{item}</DropdownItem>
            {divider && i === 2 && <DropdownItem divider />}
          </Fragment>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default ButtonDropdownList